import React from 'react';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { storage } from '@uhg-abyss/web/tools/storage';
import { TextSignature } from '../TextSignature';
import { DrawSignature } from './DrawSignature';

export const Signature = () => {
  const form = useForm();
  const radioModel = form.getValues('attestation.signatureRadio');

  return (
    <React.Fragment>
      <div style={{ marginBottom: '10px' }}>
        <RadioGroup
          model="attestation.signatureRadio"
          aria-labelledby="radio-attestation-signature"
          display="row"
          defaultValue="Text"
        >
          <RadioGroup.Radio
            id="radio-attestation-text-signature"
            value="Text"
            label="Text"
          >
            Type
          </RadioGroup.Radio>
          <RadioGroup.Radio
            id="radio-attestation-draw-signature"
            value="Draw"
            label="Draw"
          >
            Draw
          </RadioGroup.Radio>
        </RadioGroup>
      </div>
      {radioModel === 'Draw' && (
        <React.Fragment>
          <DrawSignature
            id="attestation-signature"
            model="attestation.signature"
            fileType="image/png"
            width={550}
            height={100}
            validators={{
              required: 'Signature is required.',
              save: {
                value: (value) => {
                  return value && !storage.local.get('signature-draw');
                },
                message: 'Save Signature before submitting.',
              },
            }}
            enableSave
            enableClear
          />
        </React.Fragment>
      )}
      {radioModel === 'Text' && (
        <TextSignature
          className="text"
          x={0}
          y={40}
          height={100}
          font="24px URW Chancery L, cursive"
          model="attestation.textSignatureCanvas"
          validators={{
            required: (value) => {
              return !value;
            },
          }}
          required
        />
      )}
      <p>I intend to sign this form electronically.</p>
    </React.Fragment>
  );
};
